import React from "react";
import PropTypes from "prop-types";
import { Form, Button, message } from "antd";
import { OrderedMap, Map } from "immutable";
import { INPUT_TYPES } from "constants";
import {
    fieldGenerator,
    getErrorOnField,
    getValidateStatus
} from "utilities/form";

const DOCUMENTS_TYPES = new Map({
    "Applicant PAN": 7,
    "Aadhar Front": "63-12",
    "Aadhar Back" :  "63-13",
    "Company GST": 2,
    "Applicant Photo": 6,
    "Post Sanction Kit": 56,
    "Others": 42,
    "Office CPV": 99,
    "Residence CPV": 100,
});

class UploadCompanyDoc extends React.Component {

    beforeUpload = (_) => {
        let files = [];
        const existingFiles = this.props.form.getFieldValue("files");
        if(existingFiles){
            files = [...existingFiles, _];
        }else {
            files.push(_);
        }
        this.props.form.setFieldsValue({
            "files": files
        });
        return false;
    }

    onRemove = _ => {
        let files = this.props.form.getFieldValue("files").filter(file => file.uid !== _.uid);
        this.props.form.setFieldsValue({
            "files": files
        });
    }
    
    getFormFields() {
        return new OrderedMap({
            document_type: {
                className: "form-field fb-20 p-0",
                label: "Select Document Type",
                type: INPUT_TYPES.SELECT,
                options: DOCUMENTS_TYPES.map((_, k) => ({
                    label: k,
                    value: _
                })).toList(),
                rules: [
                    {
                        required: true,
                        message: "Field Required"
                    }
                ]
            },
            associate : {
                className: "form-field fb-20 p-0",
                label: "Select Applicant",
                type: INPUT_TYPES.SELECT,
                options: this.props.associates.map((_, k) => ({
                    label:  _.name,
                    value: _.id
                })).toList(),
                rules: [
                    {
                        required: true,
                        message: "Field Required"
                    }
                ]
            },
            files: {
                className: "form-field fb-20",
                title: "Drop/Select Files",
                showUploadList: false,
                type: INPUT_TYPES.DRAGGABLEUPLOADER,
                multiple: true,
                action: null,
                rules: [
                    {
                        required: true,
                        message: "Field Required"
                    }
                ],
                onRemove: this.onRemove,
                beforeUpload:this.beforeUpload
            }
        });
    }

    formFields = this.getFormFields({ allFieldsDisabled: this.props.loading });
    fieldGenerator = fieldGenerator.bind(this.props.form);
    getErrorOnField = getErrorOnField.bind(this.props.form);
    getValidateStatus = getValidateStatus.bind(this.props.form);

    
    onValuesSubmit = e => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                let upload_files_name = []
                let duplicate_files_name = []
                values.files.map(_ => upload_files_name.push(_.name))

                this.props.files.map(_ => {
                    if(upload_files_name.includes(_.file_name) && !duplicate_files_name.includes(_.file_name)){
                        duplicate_files_name.push(_.file_name)
                    }
                    
                })
                if(duplicate_files_name.length){
                    message.error(duplicate_files_name.join(', ') + "Duplicate file name detected")
                }else{
                    this.props.onSubmit(values);
                }
            }
        });
    }

    render() {
        return (
            <Form onSubmit={this.onValuesSubmit}>
                <div className={"form-row flex-column w-100"}>
                    {this.formFields.map((field, fieldName) =>{
                        if(fieldName == "associate" &&  (!this.props.form.getFieldValue("document_type") ||  !["7" , "63-12" ,"63-13" ,"6", '100'].includes(this.props.form.getFieldValue("document_type").toString()))){
                            return; 
                        }
                        return this.fieldGenerator(
                            fieldName,
                            field,
                            this.getErrorOnField(fieldName)
                        )();
                    }
                        
                    )
                        .toList()
                        .toJS()}
                </div>
                <div className={"d-flex justify-content-center"}>
                    <Form.Item className={"m-0 w-100"}>
                        <Button className={"w-100"} type={"primary"} disabled={this.props.recreditViewOnlyPermission} htmlType={"submit"}>
                            Upload Documents
                        </Button>
                    </Form.Item>
                </div>
            </Form>
        );
    }
}

UploadCompanyDoc.propTypes = {
    form: PropTypes.object,
    values: PropTypes.array,
    onValuesSubmit: PropTypes.func,
    loading: PropTypes.bool,
    visible: PropTypes.bool,
    toggleBrandModal: PropTypes.func,
    master_erps: PropTypes.array,
    associates: PropTypes.array,
    onSubmit: PropTypes.func,
    recreditViewOnlyPermission: PropTypes.bool,
};

export default Form.create({})(UploadCompanyDoc);